import MixinOption from './options'
import {exportMarketingList} from '@api/marketing'
import MixinFormat from '@/mixins/format'

export default {
  mixins:[MixinOption,MixinFormat],
  data() {
    return {
    }
  },
  watch: {
  },
  mounted() {
  },
  methods: {
    handleExportList(){
      this.$router.push({
        path:'/admin-cms/marketing-report',
        query:{
          name:'list'
        }
      })
    },
    exportList(){
      this.mixinNetwork().exportMarketingList()
    },
    mixinNetwork(){
      return{
        exportMarketingList: async () => {
          let params ={}
          params = {...this.report_params}
          params.report_type = this.report_type
          await exportMarketingList(params)
        },
      }
    }
  }
}
